export enum EScimUrl {
  CONFIGURATION = 'configuration',
  SCIM = 'scim',
  GROUPS = 'groups',
  ENABLED = 'enabled',
}
